import { useMemo } from "react";
import { SORT_TYPES, SORT_LABELS, COUNTRY_FILTERS } from "../config/filters";

/**
 * Custom hook for generating filter dropdown options
 * @param {string} userLocation - User's location from cookies
 * @returns {Object} Sort and country filter options
 */
export const useFilterOptions = (userLocation) => {
    const sortOptions = useMemo(
        () => [
            {
                id: 1,
                label: SORT_LABELS[SORT_TYPES.PRICE_ASC],
                value: SORT_TYPES.PRICE_ASC,
            },
            {
                id: 2,
                label: SORT_LABELS[SORT_TYPES.PRICE_DESC],
                value: SORT_TYPES.PRICE_DESC,
            },
            {
                id: 3,
                label: SORT_LABELS[SORT_TYPES.LOVE_ASC],
                value: SORT_TYPES.LOVE_ASC,
            },
            {
                id: 4,
                label: SORT_LABELS[SORT_TYPES.LOVE_DESC],
                value: SORT_TYPES.LOVE_DESC,
            },
            {
                id: 5,
                label: "Reset",
                value: null,
            },
        ],
        []
    );

    const countryOptions = useMemo(
        () =>
            [
                userLocation && {
                    id: 1,
                    label: userLocation,
                    value: userLocation,
                },
                {
                    id: 2,
                    label: "Worldwide",
                    value: COUNTRY_FILTERS.WORLDWIDE,
                },
                {
                    id: 3,
                    label: "Reset",
                    value: COUNTRY_FILTERS.ALL,
                },
            ].filter(Boolean),
        [userLocation]
    );

    return {
        sortOptions,
        countryOptions,
    };
};
